import { action, makeAutoObservable } from "mobx";
import INTOUCH_API from "../services/Api";

// Баллы лояльности. balance === null — ещё не загружен (бейдж в меню скрыт).
// lastAccrual — триггер анимации «взрыва» в ЛК (сбрасывается consumeAccrual).
class Points {
  balance = null;
  history = [];
  lastAccrual = null;
  // Отложенный congrats-попап (+500 за прохождение теста): НЕ показываем сразу при
  // начислении, а когда игрок нажал «Смотреть» и попал на результаты (/matches).
  pendingCongrats = null;
  isSpending = false;
  // Статистика по реф-ссылке для блока ЛК: { passedTest, boughtGame, invitedTotal }
  referralStats = null;

  constructor() {
    makeAutoObservable(this);
  }

  setBalance(value) {
    if (value === undefined || value === null) return;
    this.balance = Number(value);
  }

  async fetchBalance() {
    await INTOUCH_API.requestManager(
      "points_balance",
      {},
      action((response) => {
        this.balance = response.data.balance;
      }),
      () => {}
    );
  }

  async fetchHistory() {
    await INTOUCH_API.requestManager(
      "points_history",
      {},
      action((response) => {
        this.history = response.data.transactions || [];
      }),
      () => {}
    );
  }

  async fetchReferralStats() {
    await INTOUCH_API.requestManager(
      "points_referral_stats",
      {},
      action((response) => {
        this.referralStats = response.data;
      }),
      () => {}
    );
  }

  // Из socket-события points-accrued: обновить баланс и (по умолчанию) завести триггер
  // «взрыва» в ЛК. Task 2: для +500 за прохождение теста взрыв в ЛК НЕ заводим
  // (silent) — анимацию «+500» показывает сам congrats-попап, чтобы порядок был
  // логичным (сначала попап, потом циферки), а не взрыв в ЛК до попапа.
  applyAccrual(amount, balance, { silent = false } = {}) {
    this.balance =
      balance !== undefined && balance !== null
        ? Number(balance)
        : (this.balance || 0) + Number(amount);
    if (!silent) this.lastAccrual = { amount: Number(amount) };
  }

  consumeAccrual() {
    this.lastAccrual = null;
  }

  // Отложить congrats-попап до нажатия «Смотреть» (только вариант +500 за прохождение).
  setPendingCongrats(payload) {
    this.pendingCongrats = payload;
  }

  consumePendingCongrats() {
    const p = this.pendingCongrats;
    this.pendingCongrats = null;
    return p;
  }

  // Оплата баллами: баланс обновляется из ответа сервера (не оптимистично),
  // чтобы UI всегда показывал авторитетное значение после списания.
  // err.response.data.message.code === 'INSUFFICIENT_POINTS' — вызывающий открывает попап «не хватает».
  async spend(type, payload, onSuccess, onError) {
    if (this.isSpending) return;
    this.isSpending = true;
    await INTOUCH_API.requestManager(
      "points_spend",
      { type, ...payload },
      action((response) => {
        this.balance = response.data.balance;
        onSuccess && onSuccess(response);
      }),
      action((error) => {
        onError && onError(error);
      }),
      action(() => {
        this.isSpending = false;
      })
    );
  }

  setInitialState() {
    this.balance = null;
    this.history = [];
    this.lastAccrual = null;
    this.pendingCongrats = null;
    this.isSpending = false;
    this.referralStats = null;
  }
}

export default new Points();
